
import React, { useState, useEffect, useRef } from 'react';

interface DebouncedInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  debounce?: number;
}

const DebouncedInput = React.forwardRef<HTMLInputElement, DebouncedInputProps>(({
  value: initialValue,
  onChange,
  debounce = 200,
  ...props
}, ref) => {
  const [value, setValue] = useState(initialValue);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const newValue = e.target.value;
    setValue(newValue);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      onChange(newValue);
    }, debounce);
  };

  return <input {...props} ref={ref} value={value} onChange={handleChange} />;
});

DebouncedInput.displayName = 'DebouncedInput';

export default DebouncedInput;
